import React, {useEffect, useState} from "react";
import {
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell,
} from "@nextui-org/react";

export default function TransactionsDetails({details}) {

    const columns = [
        {name: "PRODUCT", uid: "name"},
        {name: "ID STOCK", uid: "idstock"},
        {name: "PRECIO", uid: "sale_price"},
    ];
    const total = details?.reduce((sum, item) => sum + item.sale_price, 0);
    const renderCell = React.useCallback((transaction, columnKey) => {
        const cellValue = transaction[columnKey];
        switch (columnKey) {
            default:
                return cellValue;
        }
    }, []);

    return (
        <>
            <Table aria-label="Maquinas">
                <TableHeader columns={columns}>
                    {(column) => (
                        <TableColumn key={column.uid} align={column.uid === "actions" ? "center" : "start"}>
                            {column.name}
                        </TableColumn>
                    )}
                </TableHeader>
                <TableBody items={details} emptyContent={"Sin filas para mostrar."}>
                    {(item) => (
                        <TableRow key={item.idproduct}>
                            {(columnKey) => <TableCell>{renderCell(item, columnKey)}</TableCell>}
                        </TableRow>
                    )}
                </TableBody>
            </Table>
            <p className="text-right text-2xl" >Total: <b className="text-warning">Gs. {total}</b></p>
        </>


    );
}
